import moment from "moment"
import { NumericFormat } from "react-number-format"
import CustomerIdCell from "src/utils/customerIdCell"
import { badge } from "src/utils/statusColorsCode"
export const CardIdHandler = ({ data, handledetails, copiedId, handleCopy }) => {
    return (
        <td onClick={handledetails(data)} className='text-link'>
            <CustomerIdCell customerId={data?.id} linkText={"link"} copied={copiedId} handleCopy={handleCopy} />
        </td>
    )
}
export const CreatedDateHandler = ({ data }) => {
    return (
        <td>
            <div>
                {data?.createdDate ? <> {moment.utc(data?.createdDate).local().format("DD/MM/YYYY hh:mm:ss A")}</> : data?.createdDate}
            </div>
        </td>
    )
}
export const CardStateHandler = ({ data }) => {
    return (
        <td>
            <span className={`status-badge ${badge[data?.status.toLowerCase()] || 'bg-green'}`}>{data?.status}</span>
        </td>

    )
}
export const AuthorizationTime = ({ data }) => {
    return (
        <td>
            <div>
                {data?.transactionTime ? <> {moment.utc(data?.transactionTime).local().format("DD/MM/YYYY")}</> : data?.transactionTime}
            </div>
        </td>
    )
}

export const AuthorizationState = ({ data }) => {
    return (
        <td>
            <span className={`status-badge ${badge[data?.state?.toLowerCase()] || 'bg-green'}`}>{data?.state}</span>
        </td>
    )
}
const operationIcons = {
    "Fee": "fee-icon",
    "Freeze": "freez-icon",
    "UnFreeze": "unfreez-icon",
    "Unfreeze": "unfreez-icon",
    "SetPin": "setpin-icon",
    "BindCard": "bindcard-icon",
    "Card Creation": "card-creation-icon",
    "Cancelled": "card-cancelled-icon",
    "Top-up": "topup-icon",
    "Refund": "refund-icon",
    "Consumption": "consumption-icon",
    "First Recharge": "firstrechanrge-icon"
};
export const OperationTaskCreationTime = ({ data }) => {
    return (
        <td>
            <div>
                {data?.taskCreationTime ? <> {moment.utc(data?.taskCreationTime).local().format("DD/MM/YYYY hh:mm:ss A")}</> : data?.taskCreationTime}
            </div>
        </td>
    )
}
export const OperationCardAction = ({ data }) => {
    const cardAction = data?.cardAction;
    const iconClass = operationIcons[cardAction] || "default-icon";
    return (
        <td>
            <span className={`icon ${iconClass} mr-2`}></span>
            <span>{cardAction}</span>
        </td>
    )
}
export const OperationState = ({ data }) => {
    return (
        <td>
            <span className={`status-badge ${badge[data?.state.toLowerCase()] || 'bg-green'}`}>{data?.state}</span>
        </td>
    )
}
export const TransactionTime = ({ data }) => {
    return (
        <td>
            <div>
                {data?.time ? <> {moment.utc(data?.time).local().format("DD/MM/YYYY hh:mm:ss A")}</> : data?.time}
            </div>
        </td>
    )
}

const transactionBadge = { success: "bg-green", pending: "bg-pending", failed: "bg-red", rejected: "bg-red", freeze: "bg-pending", consume: "bg-consume", fail: "bg-red" }
export const TransactionState = ({ data }) => {
    return (
        <td>
            <span className={`status-badge ${transactionBadge[data?.state?.toLowerCase()] || 'bg-green'}`}>{data?.state}</span>
        </td>

    )
}

export const NumberFormatter = ({ value }) => {
    return<td>
      <NumericFormat 
        value={value} 
        decimalScale={2} 
        thousandSeparator={true} 
        thousandsGroupStyle="lakh" 
        displayType="text" 
      />
    </td>
};